import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {

  transform(value): any {
    if (!value) {
      return null;
    }
    return Object.keys(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/keys.pipe.ts